module.exports = __webpack_public_path__ + "assets/tooltip.4efc82bc.svg";